// extracted by mini-css-extract-plugin
export default {"active":"DesktopNavLink_active__Pp+Da","inactive":"DesktopNavLink_inactive__+UxQN","border":"DesktopNavLink_border__CH3SG"};